module.exports = __webpack_public_path__ + "img/download_data.51306d95.jpg";